export default __webpack_public_path__ + "static/media/home-corporate-parallex-bg.be2fd4a7.jpg";